
export const DEFAULT_FORM_OPTIONS = {
  isActivated: false,
}
